module.exports = __webpack_public_path__ + "img/128.e2137dd9.gif";